
module.exports = Object.freeze({
    'shape': 'shape',
    'width': 'width', 
    'height': 'height',
    'background_color': 'background-color',
    'background_opacity': 'background-opacity',
    'label': 'label',
    'label_color': 'color',
    'label_font_size' : 'font-size',
    'label_opacity' : 'text-opacity',
    'opacity': 'opacity',
    'line_color': 'line-color'
});